class ModalDialogService {
	static instance = null;

	static getInstance() {
		if (ModalDialogService.instance == null) {
			ModalDialogService.instance = new ModalDialogService();
		}

		return this.instance;
	}

	dialogs = new Map();

	register(indentifier, onToggle) {
		this.dialogs.set(indentifier, {
			onToggle,
		});
	}

	toggle(indentifier) {
		if (this.dialogs.has(indentifier)) {
			this.dialogs.get(indentifier).onToggle();
		}
	}
}

export default ModalDialogService;
